import "./Home.module.css";
import ProductionHeader from "@/reusable_sections/Header";
import ATasteOfItaly from "./sections/ATasteOfItaly";
import OurCompassionateMission from "./sections/OurCompassionateMission";
import VisualNarrative from "./sections/VisualNarrative";
import PerformanceSegments from "./sections/PerformanceSegments";
import TraditionInNumbers from "./sections/TraditionInNumbers";
import StudentSuccessStories from "./sections/StudentSuccessStories";
import ContactMessageSection from "./sections/ContactMessageSection";
import Hero from "./sections/Hero";
import Logos from "./sections/Logos";
import PiedDePage from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <ProductionHeader />
      <ATasteOfItaly />
      <OurCompassionateMission />
      <VisualNarrative />
      <PerformanceSegments />
      <TraditionInNumbers />
      <StudentSuccessStories />
      <ContactMessageSection />
      <Hero />
      <Logos />
      <PiedDePage />
    </div>;
}